import { render } from "./sorteio.vue?vue&type=template&id=19bf33ce&scoped=true"
import script from "./sorteio.vue?vue&type=script&lang=js"
export * from "./sorteio.vue?vue&type=script&lang=js"

import "./sorteio.vue?vue&type=style&index=0&id=19bf33ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bf33ce"]])

export default __exports__